import {Component, input} from '@angular/core';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  standalone: false,
})
export class LogoComponent {
  isLogin = input<boolean>(false);
}
